export default __webpack_public_path__ + "static/media/MLK_logo.d8bbd4f8.svg";